// extracted by mini-css-extract-plugin
export var button = "_qg-1";
export var container = "_qg-0";